import { useEffect, useState } from "react";
import { Copy, Crown } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Members() {
  const { member } = useAuth();
  const [data, setData] = useState(null);

  const load = () => api.get("/households/current").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);

  const isAdmin = member?.role === "admin";

  const copyCode = () => {
    navigator.clipboard.writeText(data.household.invite_code);
    toast.success("Invite code copied");
  };

  const setRole = async (id, role) => {
    try {
      await api.put(`/households/members/${id}`, { role });
      toast.success("Role updated");
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not update");
    }
  };

  if (!data) return <div className="py-16 flex justify-center"><div className="h-5 w-5 rounded-full border-2 border-primary border-t-transparent animate-spin" /></div>;

  return (
    <div className="px-5 pt-8" data-testid="members-page">
      <h1 className="text-2xl font-heading font-bold tracking-tight">Members</h1>
      <p className="mt-1 text-sm text-muted-foreground">{data.household.name}</p>

      {isAdmin && data.household.invite_code && (
        <div className="mt-4 bg-white border border-border rounded-2xl p-4">
          <p className="text-[11px] uppercase tracking-wider font-semibold text-muted-foreground">Invite your partner</p>
          <div className="mt-2 flex items-center gap-2">
            <span data-testid="invite-code" className="flex-1 text-2xl font-mono tracking-[0.3em] font-medium">{data.household.invite_code}</span>
            <button data-testid="invite-copy-btn" onClick={copyCode} className="h-11 px-4 rounded-xl border border-border flex items-center gap-2 text-sm font-medium"><Copy size={16} /> Copy</button>
          </div>
          <p className="mt-2 text-xs text-muted-foreground">They sign in with Google, choose "Join with code" and enter this code.</p>
        </div>
      )}

      <div className="mt-4 bg-white border border-border rounded-2xl overflow-hidden mb-6">
        {data.members.map((m) => (
          <div key={m.id} className="flex items-center gap-3 px-4 py-3.5 border-b border-border last:border-0">
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium truncate flex items-center gap-1">
                {m.display_name}
                {m.role === "admin" && <Crown size={14} weight="fill" className="text-transfer" />}
              </p>
              <p className="text-xs text-muted-foreground truncate">{m.email}</p>
            </div>
            {isAdmin && m.id !== member.id ? (
              <select data-testid={`member-role-${m.id}`} value={m.role} onChange={(e) => setRole(m.id, e.target.value)} className="h-10 px-2 rounded-xl bg-background border border-border text-sm">
                <option value="admin">Admin</option>
                <option value="contributor">Contributor</option>
              </select>
            ) : (
              <span className="text-xs px-2 py-1 rounded-full bg-secondary text-muted-foreground capitalize">{m.role}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
